module.exports = __webpack_public_path__ + "img/donante-lady-multitask.62f44d3e.jpeg";